<template>
  <div :class="['time-wrapper', {error: errorMessage}]">
    <label>time to send</label>
    <flat-pickr v-model="selectedTime" :config="config" name="send_at_local"></flat-pickr>
    <small class="error-label" v-if="errorMessage">{{errorMessage}}</small>
    <div class="data-description text-center" id="time-subtitle">
      {{currentMerchant.timezone}}
      <br>
      currently {{currentTime}}
    </div>
  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment-timezone'

  export default {
    props: {
      sendAt: String,
      sendAtLocal: String,
    },

    name: 'SendTimeInput',

    components: {
      flatPickr,
    },

    data() {
      return {
        config: {
          altFormat: 'h:i K',
          altInput: true,
          altInputClass: 'send-time-input flatpickr-input',
          enableTime: true,
          dateFormat: 'H:i:S',
          noCalendar: true,
          onChange: this.setSendTime,
          onClose: this.updateInteraction,
        },
        currentTime: null,
        currentInterval: null,
        noInteraction: true,
        selectedTime: null,
      }
    },

    methods: {
      setCurrentMerchantTime() {
        const view = this
        this.currentTime = this.currentMerchantTime
        setInterval(function() {
          view.currentTime = moment.tz(moment(), view.currentMerchant.merchant_time_zone).format('hh:mma')
        }, 60000)
      },

      setSendTime(selectedDates, dateStr) {
        this.updateInteraction('setSendTime')
        if (dateStr !== this.formattedSendAtLocal) {this.$emit('updateSettings', { send_at_local: dateStr }) }
      },

      updateInteraction() {
        if (this.noInteraction) {
          this.noInteraction = false
          this.$emit('setInteractions', 'time')
        }
      },
    },

    mounted() {
      this.setCurrentMerchantTime()
      this.selectedTime = this.sendAtLocal ? this.formattedSendAtLocal : null
      this.noInteraction = !this.selectedTime
      if (this.sendAtLocal) { this.$emit('setInteractions', 'time') }
    },

    computed: {
      errorMessage: function () {
        return this.sendAtLocal || this.noInteraction ? null : 'select a time'
      },

      formattedSendAtLocal: function () {
        return this.sendAtLocal ? moment(moment.utc(this.sendAtLocal)).format("HH:mm:ss") : null
      },

      ...mapGetters([
        'currentMerchantTime'
      ]),
      ...mapState([
        'currentMerchant'
      ]),
    },
  }
</script>